import React, {PureComponent} from "react";
import {Container, Col, Row} from "reactstrap";
import PubSub from 'pubsub-js';
import Widget from '../../../components/Widget';
import 'react-toastify/dist/ReactToastify.css';
import PieChart from "../../regionales/charts/PieChart";
import {Lider} from "../objects/Lider";


export class DetalleLider extends PureComponent {
    state = {
        data : [],
        total: 0,
        maxYear : this.props.maxYear,
        mes : this.props.mes,
        sectional : this.props.sectional
    }

    componentDidMount() {
        PubSub.subscribe('reloadmaxYear', this.onmaxyaer.bind(this));
        PubSub.subscribe('reloadmes', this.onmes.bind(this));
        PubSub.subscribe('reloadsectional', this.onsectional.bind(this));
        this.props.onLoading(true);
        this.getInfoSales(this.state.maxYear, this.props.mes);
    }

    onmaxyaer() {
        console.log(this.props.maxYear);
        this.props.onLoading(true);
        this.setState({
            maxYear: this.props.maxYear
        })
        this.props.onLoading(false);
    }
    onmes() {
        console.log(this.props.mes);
        this.props.onLoading(true);
        this.setState({
            mes: this.props.mes
        })
        this.props.onLoading(false);
    }
    onsectional() {
        console.log(this.props.sectional);
        this.props.onLoading(true);
        this.setState({
            sectional: this.props.sectional
        })
        this.props.onLoading(false);
    }

    componentDidUpdate() {
        this.props.onLoading(true);
        if (this.state.maxYear  != this.props.maxYear || this.state.mes != this.props.mes) {
            this.getInfoSales(this.state.maxYear, this.props.mes);
        }
    }

    getInfoSales(anio,mes) {
        this.props.onLoading(true);
        if(anio!= null){
            this.API_URL = "/LeaderCount/anio/"+anio+"/mes/"+mes
        }
        fetch(this.API_URL)
            .then((res) => res.json())
            .then((data1) => {
                console.log(data1)
                var structure = [];
                var total = 0;
                data1.map(item => {
                    total = total + item.total;
                    var lider = new Lider(item.lider, item.total);
                    structure.push(lider);
                });
                this.setState(() => ({
                    data: structure,
                    total: total
                }), ()=>{
                    this.props.onLoading(false);
                })
            });
    }


    render() {
        return(
            <Container fluid>
            <Row>
                <Col xs={12} md={12}>
                    <Widget
                        title={<h5><span className="fw-semi-bold">Team Leader </span></h5>}>
                        <PieChart data={this.state.data} />
                    </Widget>
                </Col>
                <Col xs={12} md={12}>
                    <Widget
                        title={<h5><span className="fw-semi-bold">Total Pais: {this.state.total} </span></h5>}>

                    </Widget>
                </Col>
            </Row>
            </Container>
        )
    }
}